/**
 * Copyright (c) 2018, salesforce.com, inc.
 * All rights reserved.
 * Licensed under the BSD 3-Clause license.
 * For full license text, see LICENSE.txt file in the repo root or
 * https://opensource.org/licenses/BSD-3-Clause
 */
import React from 'react';
import PropTypes from 'prop-types';
import Localized from '../../../../shared/components/Localized';
import styles from '../../../styles';
import styled from 'styled-components';

const RegionWrapper = styled.div`
  display: flex;
  flex-wrap: wrap;
  margin: 0 auto;


  background-color: #FAFAF9;
  border: 1px solid #F3F2F2;
  border-radius: 0.25rem;

  justify-content: flex-start;
  align-items: center;

  @media (max-width: 767px) {
    border-top: 1px solid #D8DDE6;
    border-bottom: 1px solid #D8DDE6;
    margin-bottom: 1rem;
  }

  @media (min-width: 768px) {
    margin: 0 1rem;
    height: 40px;
  }
`;

const RegionLabel = styled(Localized)`
  margin-left: 1rem;
  margin-right: 1rem;
  color: #3E3E3C;

  @media (max-width: 767px) {
    margin-left: 0px;
    margin-right: 0px;
    width: 100%;
    height: 40px;
    display: flex;
    align-items: center;
    background-color: #E0E5EE;
    padding-left: 1.25rem;
  }
`;

const CheckboxGroup = styled.div`
  display: flex;
  flex-wrap: wrap;

  @media (max-width: 768px) {
    background-color: #F0F8FC;
    width: 100%;
    padding: 0.25rem 0;
  }
`;

const Checkbox = styled.label`
  margin-right: 2rem;

  @media (max-width: 767px) {
    margin-right: 0px;
    margin-top: 0.25rem;
    margin-bottom: 0.25rem;
    margin-left: 1.25rem;
    width: 45%;
  }
`;

const CheckboxLabel = styled(Localized)`
  font-size: .75rem;
  color: #3E3E3C;
`;

const CheckboxInput = styled.input`
  width: 1px;
  height: 1px;
  border: 0;
  clip: rect(0 0 0 0);
  margin: -1px;
  overflow: hidden;
  padding: 0;
  position: absolute;
`;

const CheckboxFaux = styled.span`
  width: 1rem;
  height: 1rem;
  display: inline-block;
  position: relative;
  vertical-align: middle;
  border: 1px solid #d8dde6;
  border-radius: .125rem;
  background: #fff;
  transition: border .1s linear,background-color .1s linear;
  margin-right: 8px;

  ${CheckboxInput}:focus + & {
    content: '';
    border-color: #1589ee;
    box-shadow: 0 0 3px #0070D2;
  }

  ${CheckboxInput}:checked + &:after {
    display: block;
    content: '';
    height: .25rem;
    width: .5rem;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate3d(-50%,-50%,0) rotate(-45deg);
    border-bottom: 2px solid #1589ee;
    border-left: 2px solid #1589ee;
  }
`;

/**
 * React Component to that manages a group of checkboxes for React Redux fields.
 * Each checkbox its its own field whose name is the field name and value is if its
 * selected or not.
 * onFilter is optional.
 */
export default class RegionFilter extends React.Component {
  static propTypes = {
    onFilter: PropTypes.func,
    selectedOptions: PropTypes.array,
    options: PropTypes.array,
  };

  constructor(props) {
    super(props);
    this.onClick = this.onClick.bind(this);
  }

  onClick(event) {
    const { onFilter, name } = this.props;
    if (event && onFilter) {
      onFilter(event.target.value, name);
    }
  };

  render() {
    const { options, onFilter, selectedOptions, labelObject, name } = this.props;
    const _selectedOptions = selectedOptions || [];

    let optionSearch = options;
    if (!options || options.length === 0) {
      optionSearch = ['NA', 'APAC', 'EMEA'];
    }

    return (
      <RegionWrapper>
        <RegionLabel { ...labelObject } />
        <CheckboxGroup>
        { optionSearch.map((option, index) => {
          const isChecked = _selectedOptions.indexOf(option) !== -1;

          return (
            <Checkbox key={ option + name }>
              <CheckboxInput
                type='checkbox'
                checked={ isChecked }
                name={ name }
                value={ option }
                onClick={ this.onClick }
              />
              <CheckboxFaux id={`checkbox-${option}`} />
              <CheckboxLabel modelName='InstanceLocation' modelKey={option} modelAttribute="tabTitle"/>
            </Checkbox>
          );
        })}
        </CheckboxGroup>
      </RegionWrapper>
    );
  }
}
